// Filter for course category
jQuery(document).ready(function ($){
    $(".cat").each(function () {
        $(this).on("click", function () {
            $('.cat').removeClass('active');
            $(this).addClass('active');
            $('.single-case ').removeClass('active');
            $('.single-case[data-id*=' + $(this).attr('data-id') + ']').addClass('active');
            if ($(this).data('id') == 'all-items') {
                $('.single-case').addClass('active');
            }
        });
    });
});